<ion-content class="container">
  <div class="tabs-container">
    <div class="card">
      <ion-row>
        <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="borderbottomForTab">
            <mat-tab-group #tabGroup class="pt-10 pr-10 abc" [selectedIndex]="selectedTypeTabIndex" (selectedTabChange)="tabTypeChanged($event)">

       <!-- =================================== Dashboard =================================================== -->

            <ng-container *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'  || loggedInUserRole == 'HOD' || loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager'">
              <mat-tab label="dashboard">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Dashboard</span>
                </ng-template>
              </mat-tab>
            </ng-container>


        <!-- ========================= Training Gap Analysis ========================================= -->

            <ng-container *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'">
              <mat-tab label="traininggapanalysis">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      insights
                    </span>Training Gap Analysis</span>
                </ng-template>
              </mat-tab>
            </ng-container>

        <!-- ======================= My Training Calendar For Employee =================================== -->

            <ng-container *ngIf="loggedInUserRole == 'Employee' ">
              <mat-tab label="employeetrainingcalender">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      description
                    </span>My Training Calendar</span>
                </ng-template>
              </mat-tab>
            </ng-container>

        <!-- ====================== Employee Feedback For Employee ==================================== -->

            <ng-container *ngIf="loggedInUserRole == 'Employee'">
              <mat-tab label="employeefeedback">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      description
                    </span> Feedback</span>
                </ng-template>
              </mat-tab>
            </ng-container>
        

        <!-- =====================  Training Calendar  ================================================== -->

            <ng-container *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
              <mat-tab label="trainingcalendor">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      event_note
                    </span>Training Calendar</span>
                </ng-template>
              </mat-tab>
            </ng-container>

        
        <!-- ================== Training Calendar For HOD and Manager ===================================== -->

            <ng-container *ngIf="loggedInUserRole == 'HOD' || loggedInUserRole == 'Manager'">
              <mat-tab label="hodtrainingcalendor">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      event_note
                    </span>Training Calendar</span>
                </ng-template>
              </mat-tab>
            </ng-container>


          <!--  ==================== Feedback for Manager and HOD ========================================= -->

          <ng-container *ngIf="loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
            <mat-tab label="feedbackformanager">
              <ng-template mat-tab-label>
                <span style="display: contents;">
                  <span class="material-icons mr-10">
                    description
                  </span> Feedback</span>
              </ng-template>
            </mat-tab>
          </ng-container>

        <!-- ======================= HOD identified calendor ================================================== -->
            
              <ng-container *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
              <mat-tab label="hodIdentifiedCalendar">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      assignment_ind
                    </span>HOD Identified Calendar</span>
                </ng-template>
              </mat-tab>
            </ng-container>

         <!-- ======================= HOD identified calendor for HOD  ================================================== -->

              <ng-container *ngIf="loggedInUserRole === 'HOD'">
                <mat-tab label="calenderforhod">
                  <ng-template mat-tab-label>
                    <span style="display: contents;">
                      <span class="material-icons mr-10">
                        assignment_ind
                      </span>HOD Identified Calendar
                    </span>
                  </ng-template>
                </mat-tab>
              </ng-container>

          <!-- ============================= Program Attendance ========================================================= -->

              <ng-container *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
              <mat-tab label="programattendance">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      how_to_reg
                    </span>Program Attendance</span>
                </ng-template>
              </mat-tab>
            </ng-container>

          
          <!-- =====================================  Reports ===================================================================== -->

              <ng-container *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'Manager' || loggedInUserRole == 'HOD'">
              <mat-tab label="reports">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      description
                    </span>Reports</span>
                </ng-template>
              </mat-tab>
            </ng-container>
           
            </mat-tab-group>
          </div>
        </ion-col>


        <!-- ============================================= Setup ============================================================== -->

        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="borderbottomForTab pl-10 pt-10 pr-10">
          <div class="center-content float-right">
            <div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
              <button type="button" class="add_btn fs-14 float-right center-content mr-5"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup</button>      
            </div>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>


    <!------------------------------------ Tabs Components ----------------------------------------------------  -->


  <div class="card  ">

       <!-- ========== Dashboard ==================== -->
    <div class="p-10" *ngIf="selectedTypeTabName=='dashboard'">
      <app-lnd-dashboard></app-lnd-dashboard>
    </div>
  
    
       <!-- ========== Training Gap Analysis ==================== -->

       <div class="p-10" *ngIf="selectedTypeTabName=='traininggapanalysis'">
        <app-training-gap-analysis></app-training-gap-analysis>
      </div>
    

       <!-- ======Training calendor HR Admin======= -->

    <div class="p-10" *ngIf="selectedTypeTabName=='trainingcalendor'">
      <app-training-calendor></app-training-calendor> 
    </div>

    <!-- ======Training calendor for HOD and Manager======= -->
    <div class="p-10" *ngIf="selectedTypeTabName=='hodtrainingcalendor'">
      <app-hod-training-calendor></app-hod-training-calendor>
    </div>

    <!-- =========Identified calendor ===== -->
  
    <div class="p-10" *ngIf="selectedTypeTabName=='hodidentifiedcalendar'">
      <app-hod-identified-calendar></app-hod-identified-calendar>
    </div>

    
    <!-- =========Identified calendor for HOD====== -->

    <div class="p-10" *ngIf="selectedTypeTabName=='calenderforhod'">
      <app-identified-calender-for-hod></app-identified-calender-for-hod>
    </div>

    <!-- =========  Employee Feedback ============ -->
  
        <div class="p-10" *ngIf="selectedTypeTabName=='employeefeedback'">
          <app-employee-feedback></app-employee-feedback>
        </div>
    
       <!-- =============== Manager Feedback ======== -->
      
         <div class="p-10" *ngIf="selectedTypeTabName=='feedbackformanager'">
          <app-manager-feedback></app-manager-feedback>
        </div>
    

      <!-- =========My training Calendar Employee====== -->
  
      <div class="p-10" *ngIf="selectedTypeTabName=='employeetrainingcalender'">
        <app-my-training-calender-employee></app-my-training-calender-employee>
      </div>

  
  
     <!-- =========Program Attendance================= -->

   <div class="p-10" *ngIf="selectedTypeTabName=='programattendance'">
      <app-program-attendance></app-program-attendance>
    </div>


      <!-- =========Reports================= -->

  <div class="p-10" *ngIf="selectedTypeTabName=='reports'">
      <app-reports></app-reports>
    </div>
  
  </div>
</ion-content>



